<div class="alertas" *ngIf="abierto">

  <div class="alertaComponent {{alerta.Clase}} animated {{alerta.Animacion}}">

    <div class="alertaGrupo">

      <div class="icono">
        <span style="font-size: 24px" class="{{alerta.Icono}}"></span>
      </div>

      <div class="descripcion">
        <span> {{alerta.Descripcion}}</span>
      </div>

    </div>

  </div>

</div>
